import { render } from "./SectionProjectsMain.vue?vue&type=template&id=35c38c2a&scoped=true"
import script from "./SectionProjectsMain.vue?vue&type=script&lang=js"
export * from "./SectionProjectsMain.vue?vue&type=script&lang=js"

import "./SectionProjectsMain.vue?vue&type=style&index=0&id=35c38c2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c38c2a"]])

export default __exports__